import { Textarea, TextareaProps } from '@chakra-ui/react'
import { useCallback, useRef } from 'react'

const MAX_LINES = 3

export const AutoResizeTextArea = (props: TextareaProps) => {
  const ref = useRef<HTMLTextAreaElement>(null)

  const resize = useCallback(() => {
    const el = ref.current
    if (!el) return
    el.style.height = 'auto'
    const lineHeight = parseFloat(getComputedStyle(el).lineHeight) || 20
    const maxHeight = lineHeight * MAX_LINES
    el.style.height = `${Math.min(el.scrollHeight, maxHeight)}px`
    el.style.overflowY = el.scrollHeight > maxHeight ? 'auto' : 'hidden'
  }, [])

  return (
    <Textarea
      ref={ref}
      rows={1}
      overflow="hidden"
      resize="none"
      {...props}
      onInput={e => {
        resize()
        props.onInput?.(e)
      }}
    />
  )
}
